<template>
  <div>
    <div class="toolbar">
      <ListSearchForm @change="fetchData" ref="search" style="display:inline-block;"></ListSearchForm>
      <el-button type="primary" @click="handleBatch">添加题目</el-button>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
      @sort-change="handleSort"
    >
      <el-table-column type="selection" width="60"></el-table-column>
      <el-table-column prop="id" label="ID" width="60" sortable="custom"></el-table-column>
      <el-table-column prop="plid" label="课程" width="100"></el-table-column>
      <el-table-column label="内容">
        <template v-slot="column">
          <ExercisePreview :entity="column.row"></ExercisePreview>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="updateModel(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-if="total>pageSize"
    >
    </el-pagination>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%">
      <ExerciseForm ref="exrform" :types="types"></ExerciseForm>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitModel">确 定</el-button>
      </div>
    </el-dialog>
    <Sidebar :visible.sync="batchVisible" header="批量添加">
      <ExerciseForm ref="batchform"></ExerciseForm>
      <div class="text-right">
        <el-button @click="batchVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBatch">确 定</el-button>
      </div>
    </Sidebar>
  </div>
</template>

<script>
import ExerciseForm from './ExerciseForm'
import ExercisePreview from './../../../components/exercise/ExercisePreview'
import Sidebar from './../../../components/Sidebar'
import table from './../../../components/mixins/table.js'
import ListSearchForm from './ListSearchForm'

export default {
  name: 'ExerciseList',
  props: {
    knowtype: String
  },
  mixins: [table],
  data () {
    return {
      types: [],
      multipleSelection: [],
      dialogTitle: '添加题目',
      dialogVisible: false,
      batchVisible: false,
      fetchUrl: 'pinyin_exercise_list'
    }
  },
  components: { ExerciseForm, ExercisePreview, Sidebar, ListSearchForm },
  created () {
    this.fetchTypes()
  },
  watch: {
    knowtype () {
      this.fetchData()
    }
  },
  methods: {
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    fetchTypes () {
      return this.$http.get(this.$urls.exercise_type_list, {
        params: {
          page: 1,
          'per-page': 1000
        }
      }).then(res => {
        this.types = res.data
      })
    },
    handleFetchConfig (config) {
      if (this.$refs.search) {
        Object.assign(config.params, {
          'filter[id]': this.$refs.search.eid,
          'filter[plid]': this.$refs.search.lid,
          'filter[tid]': this.$refs.search.tid,
          'filter[data_json][like]': this.$refs.search.search
        })
      } else {
        Object.assign(config.params, {
          status: 1,
          knowType: this.knowtype
        })
      }
    },
    createModel () {
      this.dialogVisible = true
      this.dialogTitle = '添加题目'
      window.setTimeout(() => {
        if (this.$refs.exrform.model.id) {
          this.$refs.exrform.reset()
        }
      }, 10)
    },
    submitModel () {
      this.$refs.exrform.submit().then(res => {
        this.dialogVisible = false
        this.fetchData()
        this.$refs.exrform.reset()
      })
    },
    updateModel (item) {
      this.dialogVisible = true
      this.dialogTitle = '编辑题目: ' + item.id
      setTimeout(() => {
        this.$refs.exrform.reset(item)
      }, 10)
    },
    handleBatch () {
      this.batchVisible = true;
    },
    submitBatch () {
      this.$refs.batchform.submit().then(() => {
        this.fetchData()
        this.$refs.batchform.reset({
          tid: this.$refs.batchform.model.tid,
          level: this.$refs.batchform.model.level,
          lid: this.$refs.batchform.model.lid
        })
      })
    },
    handleDelete (item) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.$http.put(this.$urls.exercise_update, { status: 0 }, {
          params: {id: item.id}
        }).then(() => {
          this.fetchData()
        })
      })
    }
  }
}
</script>